import { useEffect, useRef } from 'react';
import { PaymentMethod } from '@frontend/api-payment-plans';

export type UseSelectDefaultPaymentMethodProps = {
  onSelectPaymentMethod: (pm: PaymentMethod) => void;
  selectedPaymentMethod: PaymentMethod | null;
  defaultPaymentMethod: PaymentMethod | undefined;
  selectOnlyOnMount?: boolean;
};
export const useSelectDefaultPaymentMethod = ({
  onSelectPaymentMethod,
  selectedPaymentMethod,
  defaultPaymentMethod,
  selectOnlyOnMount = true,
}: UseSelectDefaultPaymentMethodProps) => {
  const hasSelectedRef = useRef(false);

  useEffect(() => {
    if (selectOnlyOnMount && hasSelectedRef.current) {
      return;
    }

    if (defaultPaymentMethod && !selectedPaymentMethod) {
      onSelectPaymentMethod(defaultPaymentMethod);
      hasSelectedRef.current = true;
    }
  }, [defaultPaymentMethod, selectedPaymentMethod, onSelectPaymentMethod, selectOnlyOnMount]);
};
